import React from 'react'
import { useEnv } from '@praxis/component-runtime-env'
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from '@mui/material'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import { fileValidationTexts } from '../../constants/common'
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import { DeleteForever } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import { getStudioAndProcess } from '../Workflow/constants'

const useStyles = makeStyles(() => ({
  padding_left_right_null: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
  iconWithDesc: {
    display: 'flex',
    alignItems: 'center',
  },
  uploadTableColumn: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '17px',
    color: '#666666',
  },
  filter: {
    minWidth: '160px !important',
  },
}))

export default function NewImageFilesTable({
  newImageFiles,
  onNewDelete,
  handleStudioChange = () => {},
  handleCascade = () => {},
  isCascade = false,
  page = '',
}) {
  const env = useEnv()
  const { enableAdditionalImages = false } = env
  const studioAndProcess = getStudioAndProcess(enableAdditionalImages)
  const classes = useStyles()

  const renderStudioOptions = () => {
    return studioAndProcess
      ? studioAndProcess?.map((option) => (
          <MenuItem key={option.val} value={option.val}>
            {option.label}
          </MenuItem>
        ))
      : ''
  }

  const renderTableHeader = () => {
    return (
      <TableRow>
        <TableCell
          align="left"
          className={`${classes.padding_left_right_null} ${classes.uploadTableColumn}`}
        >
          New Images for Ingestion ({newImageFiles.length})
        </TableCell>
        <TableCell
          align="left"
          className={`${classes.padding_left_right_null} ${classes.uploadTableColumn}`}
        ></TableCell>
        <TableCell
          colSpan={2}
          align="left"
          className={`${classes.padding_left_right_null} ${classes.uploadTableColumn}`}
        >
          Studio Name
        </TableCell>
        <TableCell
          colSpan={2}
          align="left"
          className={`${classes.padding_left_right_null} ${classes.uploadTableColumn}`}
        ></TableCell>
      </TableRow>
    )
  }

  return (
    <>
      {newImageFiles.length ? (
        <Table sx={{ width: '100%' }} aria-label="simple table">
          <TableHead style={{ background: '#EAF5F9' }}>
            {renderTableHeader()}
          </TableHead>
          <TableBody>
            {newImageFiles.length ? (
              newImageFiles.map((row, i) => (
                <TableRow key={row.name}>
                  <TableCell
                    className={classes.padding_left_right_null}
                    align="left"
                    padding="none"
                    component="th"
                    scope="row"
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    className={classes.padding_left_right_null}
                    align="left"
                  >
                    <span className={classes.iconWithDesc}>
                      {row.validationText === 'Validating' ? (
                        <></>
                      ) : row.validationText === fileValidationTexts.new ||
                        (page === 'ingestion' &&
                          row.validationText === fileValidationTexts.valid) ? (
                        <CheckCircleOutlinedIcon
                          style={{
                            color: '#00A324',
                            marginRight: '5px',
                          }}
                        />
                      ) : (
                        <ReportProblemOutlinedIcon
                          style={{
                            color: '#BD6839',
                            marginRight: '5px',
                          }}
                        />
                      )}
                      {row.validationText}
                    </span>
                  </TableCell>
                  <TableCell
                    className={classes.padding_left_right_null}
                    align="left"
                  >
                    <Grid container alignItems="center">
                      <Grid item>
                        <FormControl
                          variant="outlined"
                          className={classes.filter}
                        >
                          <InputLabel id="studio-filter-label">
                            Studio
                          </InputLabel>
                          <Select
                            label="Studio"
                            value={row.studio || ''}
                            onChange={(e) => {
                              handleStudioChange(
                                row.name || row,
                                e.target.value
                              )
                            }}
                            labelId="studio-filter-label"
                          >
                            {renderStudioOptions()}
                          </Select>
                        </FormControl>
                      </Grid>
                      {isCascade && (
                        <Grid item>
                          <IconButton
                            aria-label="cascade"
                            disabled={!row?.studio}
                            onClick={() => handleCascade(row.studio)}
                          >
                            <Tooltip
                              title="Apply the same studio to all files"
                              arrow
                            >
                              <SwapVertIcon />
                            </Tooltip>
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                  </TableCell>
                  <TableCell
                    className={classes.padding_left_right_null}
                    align="left"
                  >
                    <IconButton
                      aria-label="delete"
                      disabled={row.validationText === 'Validating'}
                      onClick={() => onNewDelete(row)}
                    >
                      <DeleteForever />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No Selected Image
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      ) : (
        <></>
      )}
    </>
  )
}
